<template>
  <div
    class="tab-options"
    :class="`step-${activeTab}`"
    v-if="tabStep === 'steps'"
  >
    <div
      v-for="(step, stepIndex) of getEnabledTabs()"
      :key="stepIndex"
      class="tab"
      :class="{
        active: activeTab === step.index,
        enabled: activeTab > step.index,
      }"
      @click="selectTab(step.alias)"
    >
      <div class="d-flex align-start">
        <span class="number" :class="{ done: activeTab > step.index }">
          <i class="fal fa-check" v-if="activeTab > step.index && isMobile" />
          <span v-else>{{ stepIndex + 1 }}</span>
        </span>
        <div class="d-flex flex-column flex">
          <p class="name">{{ step.description }}</p>

          <p v-if="step.subdescriptionType == 'text'" class="textMessages">
            {{ step.subdescription }}
          </p>
          <div v-else-if="step.subdescriptionType == 'tags'" class="tags">
            <div
              v-for="(item, itemIndex) of step.subdescription"
              :key="itemIndex"
              class="tag"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

const STEPS = {
  NAME_STEP: 1,
  TYPE_STEP: 2,
  SEGMENTATION_STEP: 3,
  COUPON_STEP: 4,
  DELIVERY_STEP: 5,
  TEXT_STEP: 6,
  TIME_STEP: 7,
};

const SEGMENT_NAME = {
  behavioralDaysOff: 'Dias sem pedir',
  behavioralRespondSatisfactionSurvey: 'Responde pesquisa de satisfação',
  behavioralBirthday: 'Aniversáriante',
  clientAgeRange: 'Faixa etária',
  clientRegisterTimer: 'Tempo de cadastro',
  clientAverageTicket: 'Ticket médio',
  clientOrderQuantity: 'Quantidade de pedidos',
  clientTotalSpent: 'Total gasto',
  geographicDistrict: 'Bairro',
  geographicDistance: 'Distância',
};

export default {
  props: {
    activeTab: { type: Number, default: 1 },
    campaign: { type: Object, default: () => ({ type: null }) },
    tabStep: { type: String, default: 'steps' },
  },
  data() {
    return {
      STEPS,
      tabs: {
        NAME_STEP: {
          alias: 'NAME_STEP',
          index: 1,
          description: 'Nome de campanha',
          subdescription: null,
          subdescriptionType: 'text',
          enabled: false,
        },
        TYPE_STEP: {
          alias: 'TYPE_STEP',
          index: 2,
          description: 'Tipo de ação',
          subdescription: null,
          subdescriptionType: 'text',
          enabled: false,
        },
        SEGMENTATION_STEP: {
          alias: 'SEGMENTATION_STEP',
          index: 3,
          description: 'Segmentações',
          subdescription: null,
          subdescriptionType: 'tags',
          enabled: false,
        },
        COUPON_STEP: {
          alias: 'COUPON_STEP',
          index: 4,
          description: 'Benefícios',
          subdescription: null,
          subdescriptionType: 'text',
          enabled: false,
        },
        DELIVERY_STEP: {
          alias: 'DELIVERY_STEP',
          index: 5,
          description: 'Formas de envio',
          subdescription: null,
          subdescriptionType: 'text',
          enabled: false,
        },
        TEXT_STEP: {
          alias: 'TEXT_STEP',
          index: 6,
          description: 'Mensagem',
          subdescription: null,
          subdescriptionType: 'text',
          enabled: false,
        },
        TIME_STEP: {
          alias: 'TIME_STEP',
          index: 7,
          description: 'Disparo',
          subdescription: null,
          subdescriptionType: 'text',
          enabled: false,
        },
      },
    };
  },
  methods: {
    getEnabledTabs() {
      const { campaign } = this.$props;
      const tabs = JSON.parse(JSON.stringify(this.tabs));

      switch (campaign.type) {
        case 'API':
          for (const stepIndex in tabs) {
            tabs[stepIndex].enabled =
              ['SEGMENTATION_STEP', 'TIME_STEP'].indexOf(stepIndex) == -1;
          }
          break;
        case 'APA':
        case 'ARC':
        case 'ARD':
        default:
          for (const stepIndex in this.tabs) {
            tabs[stepIndex].enabled = true;
          }
      }

      return Object.values(tabs).filter((step) => step.enabled);
    },
    selectTab(tabAlias) {
      if (this.tabs[tabAlias].index < this.activeTab) {
        this.$emit('selectTab', {
          tabAlias,
          tabIndex: this.tabs[tabAlias].index,
        });
      }
    },
    getDeliveryName(sendType) {
      switch (sendType) {
        case 'sms':
          return 'SMS';
        case 'whatsapp':
          return 'Whatsapp';
        case 'email':
          return 'E-mail';
        default:
          return '';
      }
    },
    getActionName(actionType) {
      switch (actionType) {
        case 'ARD':
          return 'Ação de recorrência de data';
        case 'ARC':
          return 'Ação de recorrência de conversão';
        case 'APA':
          return 'Ação pontual agendada';
        case 'API':
          return 'Ação pontual imediata';
        default:
          return '';
      }
    },
    buildSegmentationTags(segmentations = []) {
      const segments = [];
      segmentations.forEach((s) => {
        const { value, field } = s;
        if (value.min || value.max) {
          segments.push(`${SEGMENT_NAME[field]} (${value.min}-${value.max})`);
        } else if (field === SEGMENT_NAME[field]) {
          segments.push(`${value.address}`);
        } else if (value.minimum) {
          segments.push(`${SEGMENT_NAME[field]} +(${value.minimum})`);
        } else if (value.exact) {
          segments.push(`${SEGMENT_NAME[field]} (${value.exact})`);
        } else {
          segments.push(`${SEGMENT_NAME[field]} `);
        }

        if (value.isLast && value.field) {
          switch (value.field) {
            case '1':
              segments.push(`No(s) último(s) ${value.isLast} dia(s)`);
            case '2':
              segments.push(`No(s) último(s) ${value.isLast} mes(es)`);
            case '3':
              segments.push(`No(s) último(s) ${value.isLast} ano(s)`);
          }
        }
      });
      return segments;
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
    }),
  },
  watch: {
    $props: {
      immediate: true,
      deep: true,
      handler({ campaign }) {
        const { configs } = campaign;
        this.tabs.NAME_STEP.subdescription = campaign.name;
        this.tabs.TYPE_STEP.subdescription = this.getActionName(campaign.type);
        this.tabs.COUPON_STEP.subdescription =
          configs.gift == -1 && !configs.gift.code
            ? `Sem benefício`
            : configs.gift.code;
        this.tabs.DELIVERY_STEP.subdescription = this.getDeliveryName(
          configs.type_send
        );
        this.tabs.TEXT_STEP.subdescription =
          configs.content &&
          configs.content.sms &&
          configs.content.sms.message &&
          configs.content.sms.message.text;
        this.tabs.SEGMENTATION_STEP.subdescription =
          configs.segmentations && configs.segmentations.length > 0
            ? this.buildSegmentationTags(configs.segmentations)
            : [];
      },
    },
  },
};
</script>
<style scoped>
.textMessages {
  max-width: 40ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tab-container .tab-options {
  display: flex;
  flex-direction: column;
  width: 20%;
  min-width: 320px;
  position: relative;
  background: #3a3c40;
  padding: 5px 0;
  border-radius: 5px;
  font-weight: 500;
}

@media screen and (max-width: 991px) {
  .tab-container .tab-options {
    width: 100%;
  }
}

.tab-container .tab-options .tab {
  padding: 20px 35px;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  transition: all 0.1s ease;
  min-height: 100px;
}

.tab-container .tab-options .tab:not(.enabled) {
  cursor: not-allowed;
}

.tab-container .tab-options .tab .number {
  background: #46484d;
  border-radius: 50%;
  font-weight: bold;
  color: #aaaaab;
  font-size: 12px;
  margin-right: 17px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 15px;
}
@media screen and (max-width: 991px) {
  .tab-container .tab-options .tab {
    min-height: 80px;
    padding: 20px;
    transition: none;
  }
  .tab-container .tab-options .tab .number {
    width: 22px;
    height: 22px;
  }
  .tab-container .tab-options .tab .number.done {
    background: #288c79;
    color: #fff;
  }
}
.tab-container .tab-options .tab .name {
  font-size: 14px;
  line-height: 17px;
  color: #999;
  margin-bottom: 10px;
}
.tab-container .tab-options .tab p:not(.name) {
  color: #aaaaabd9;
  line-height: 15px;
  font-size: 12px;
}
.tab-container .tab-options .tab:not(.active).enabled:hover {
  background: #414347;
}
.tab-container .tab-content {
  width: 80%;
  padding: 25px;
  background: #3a3c40;
  overflow: auto;
  margin-left: 20px;
  border-radius: 5px;
  height: 100%;
}

@media screen and (max-width: 991px) {
  .tab-container .tab:after {
    content: '\f054';
    font-family: 'Font Awesome 5 Pro';
    position: absolute;
    right: 25px;
    font-size: 12px;
    color: #8c8c8c;
  }
  .tab-container .tab-content {
    width: 100%;
    margin: 0;
    position: relative;
    padding: 17px 20px;
  }
}
@media screen and (min-width: 992px) {
  .tab-container .tab.active {
    background: #4e3b47;
  }
  .tab-container .tab.active:before {
    content: '';
    height: 60px;
    width: 2px;
    position: absolute;
    left: 0;
    background: var(--default);
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .tab-container .tab-options .tab:not(:last-child) {
    margin-bottom: 15px;
  }
  .tab-container .tab-options .tab.active .number {
    background: var(--default);
    color: #fff;
  }
  .tab-container .tab-options .tab.active .name {
    color: var(--default);
    font-weight: bold;
  }
  .tab-container .tab-options .tab.active p:not(.name) {
    font-weight: bold;
  }
}

.tab-container .tab-options:before {
  content: '';
  height: 85%;
  width: 2px;
  position: absolute;
  left: 45px;
  background: #aaaaab33;
  top: 0;
  bottom: 0;
  margin: auto;
}

@media screen and (max-width: 991px) {
  .tab-container .tab-options .tab .name {
    color: var(--label-secondary);
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
  }
  .tab-container .tab-options .tab p:not(.name) {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    color: #aaaaabf2;
  }
  .tab-container .tab-options:before {
    left: 30px;
  }
  .tab-container .tab-options.step-1:before {
    background: linear-gradient(to bottom, #288c79 0%, #aaaaab33 0%);
  }
  .tab-container .tab-options.step-2:before {
    background: linear-gradient(to bottom, #288c79 15%, #aaaaab33 15%);
  }
  .tab-container .tab-options.step-3:before {
    background: linear-gradient(to bottom, #288c79 15%, #aaaaab33 35%);
  }
  .tab-container .tab-options.step-4:before {
    background: linear-gradient(to bottom, #288c79 35%, #aaaaab33 60%);
  }
  .tab-container .tab-options.step-5:before {
    background: linear-gradient(to bottom, #288c79 60%, #aaaaab33 70%);
  }
  .tab-container .tab-options.step-6:before {
    background: linear-gradient(to bottom, #288c79 80%, #aaaaab33 90%);
  }
  .tab-container .tab-options.step-7:before {
    background: linear-gradient(to bottom, #288c79 90%, #aaaaab33 100%);
  }
}
.tags {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.tags .tag {
  color: var(--label-secondary);
  font-weight: bold;
  padding: 5px 10px;
  font-size: 10px;
  line-height: 12px;
  border-radius: 7px;
  border: 1px solid #ffffff17;
  margin-bottom: 5px;
  margin-right: 5px;
}

@media screen and (max-width: 991px) {
  .tabs-steps {
    color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #2d2f32;
    position: fixed;
    bottom: 60px;
    padding: 5px;
    left: 0;
    right: 0;
  }
  .tags .tag {
    color: #aaaaabf2;
    padding: 5px 10px;
    border-radius: 5px;
    border: 1px solid #505359;
    margin-bottom: 5px;
    margin-right: 5px;
  }

  .tabs-steps .tab {
    border-radius: 5px;
    padding: 10px;
    width: 100%;
    text-align: center;
  }

  .tabs-steps .tab.active {
    background: #45484d80;
  }

  .tabs-steps .tab p {
    color: var(--label-primary);
    font-size: 14px;
    line-height: 17px;
  }

  .tabs-steps .tab.active p {
    color: var(--label-secondary);
    font-weight: bold;
  }
  .progress-line,
  .progress-line > .done {
    position: absolute;
    width: 100%;
    height: 3px;
    left: 0;
    right: 0;
    top: 0;
  }
  .progress-line {
    background: #99999938;
  }
  .done {
    background: var(--default);
  }
  .help {
    padding-bottom: 0;
    border-bottom: none;
  }
  .cost {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    padding: 5px 20px;
  }
}
</style>
